import React from "react";
import {injectIntl} from "react-intl";
import styles from "./styles/sport-form.css";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import PageHeaderBar from "../../../../components/page/components/page-header-bar/page-header-bar";
import PageSection from "../../../../components/page/components/page-section/page-section";
import DataGrid from "../../../../components/data-grid/data-grid";
import Card from "../../../../components/card/card/card";
import DataGridItem from "../../../../components/data-grid/data-grid-item";
import FormTextField from "../../../../components/form/form-textfield/form-textfield";

const LocalRecEvent = ({handleChange, intl, values}) => {
    return <>
        <PageHeaderBar subtitle title="event.local.rec.in.true"/>
        <PageSection hideBackground>
            <DataGrid>
                <Card>
                    <DataGridItem>
                       <FormTextField
                                type="text"
                                id="localRecInfo.local_rec_emails"
                                name="localRecInfo.local_rec_emails"
                                value={values.local_rec_emails}
                                onChange={handleChange}
                                label={intl.formatMessage({id: "common.local_rec_emails"})}
                       />
                    </DataGridItem>
                </Card>
            </DataGrid>
        </PageSection>
    </>
}


LocalRecEvent.propTypes = {
    /**
     * Otros datos del evento a editar que no se envían en el form
     */
    eventToEdit: PropTypes.object,
    /**
     * Indica si es un formulario nuevo
     */
    isNewForm: PropTypes.bool,
    /**
     * Customer id del contrato del evento
     */
    eventCustomerId: PropTypes.string,
    /**
     * Valores del formulario
     */
    values: PropTypes.object,
    /**
     * Callback que se dispara con el cambio del input
     */
    handleChange: PropTypes.func,
};

export default injectIntl(withStyles(styles)(LocalRecEvent));
